import { useState, useEffect, useRef } from 'react';
import type { TimeRange } from '../components/charts/PriceChart';
import type { TiingoNewsArticle } from '../api/newsTypes';
import { fetchAssetNews } from '../api/newsClient';

interface UseAssetNewsResult {
    articles: TiingoNewsArticle[];
    loading: boolean;
}

export function useAssetNews(
    ticker: string | undefined,
    timeRange: TimeRange,
): UseAssetNewsResult {
    const [articles, setArticles] = useState<TiingoNewsArticle[]>([]);
    const [loading, setLoading] = useState(false);
    const abortRef = useRef<AbortController | null>(null);

    useEffect(() => {
        if (!ticker) {
            setArticles([]);
            return;
        }

        abortRef.current?.abort();
        const controller = new AbortController();
        abortRef.current = controller;

        setLoading(true);
        fetchAssetNews(ticker, timeRange, controller.signal)
            .then(data => {
                if (!controller.signal.aborted) {
                    setArticles(data);
                    setLoading(false);
                }
            })
            .catch((err) => {
                if (!controller.signal.aborted) {
                    console.warn('useAssetNews: unexpected rejection:', err);
                    setArticles([]);
                    setLoading(false);
                }
            });

        return () => controller.abort();
    }, [ticker, timeRange]);

    return { articles, loading };
}
